import React, { useState, useEffect, useCallback, useContext } from "react"
import StatusIconText from "../../../components/StatusIconText"
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import { ErrorPage } from "../../AuxiliarPages/ErrorPage/ErrorPage"
import { LoadingPage } from "../../AuxiliarPages/LoadingPage/LoadingPage"
import { DataField } from "../../../components/DataField"
import { DatetimeBlock } from "../../../components/DatetimeBlock"
import AuthContext from "../../../context/auth-context"
import ErrorBoundary from "../../AuxiliarPages/ErrorBoundary/ErrorBoundary"
import { formatPhoneObjectToFront } from "../../../utils/utils"
import BaseButton from "../../../components/BaseButton"
import LoadingIcon from "../../../assets/images/loading.svg"
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import EventNoteIcon from '@mui/icons-material/EventNote'
import { CancelEnvelopeFolderDecisionDialog } from "./CancelEnvelopeFolderDecisionDialog/CancelEnvelopeFolderDecisionDialog"
import { CancelEnvelopeFolderErrorDialog } from "./CancelEnvelopeFolderErrorDialog/CancelEnvelopeFolderErrorDialog"
import EnvelopeFolderEventsDialog from "./EnvelopeFolderEventsDialog/EnvelopeFolderEventsDialog"
import * as S from "../styles"

export const EnvelopeFolderPage = (props) => {

    const folderKey = useParams().folderKey
    const navigate = useNavigate()
    const userRoles = useContext(AuthContext).user_data.roles

    if (!userRoles.includes("read_envelope_folder")) {
        navigate("/folder-inbox")
    }

    const [fetchedData, setFetchedData] = useState(undefined)
    const [error, setError] = useState({
        hasError: false,
        statusCode: 200
    })
    const [loading, setLoading] = useState(true)

    const fetchEnvelopeFolderData = useCallback(() => {
        const timer = setTimeout(() => {
            axios.get(`/dash/sign/envelope_folder/${folderKey}`)
                .then((response) => {
                    setFetchedData(response.data)
                })
                .catch((error) => {
                    if ([404].includes((error.response || {}).status)) {
                        navigate("/folder-inbox")
                    } else {
                        setError({
                            "hasError": true,
                            "statusCode": 500
                        })
                    }
                })
                .finally(() => {
                    setLoading(false)
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }, [folderKey])

    useEffect(() => {
        return fetchEnvelopeFolderData()
    }, [fetchEnvelopeFolderData])

    const [folderEventsDialogOpen, setFolderEventsDialogOpen] = useState(false)
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false)
    const [cancelEnvelopeFolderLoading, setCancelEnvelopeFolderLoading] = useState(false)
    const [cancelEnvelopeFolderError, setCancelEnvelopeFolderError] = useState(false)

    const cancelEnvelopeFolder = () => {
        if (cancelEnvelopeFolderLoading) return
        const submissionData = {
            "status": "canceled"
        }
        setCancelEnvelopeFolderLoading(true)
        const timer = setTimeout(() => {
            axios.patch(`/dash/sign/envelope_folder/${folderKey}`, submissionData)
                .then((response) => {
                    window.location.reload()
                })
                .catch((error) => {
                    setCancelEnvelopeFolderError(true)
                })
                .finally(() => {
                    setCancelEnvelopeFolderLoading(false)
                    setCancelDialogOpen(false)
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }

    if (loading) {
        return (
            <LoadingPage />
        )
    } else if (error.hasError) {
        return (
            <ErrorPage />
        )
    } else if (fetchedData) {
        return (
            <div className="page-container">
                <S.DataTablesRow>
                    <ul className="inbox">
                        <li className="inbox__header">
                            <div className="inbox__cell--left">Dados da Pasta:</div>
                        </li>
                        <li className="inbox__body_d_block">
                            <S.DataTable>
                                <tbody>
                                    <tr>
                                        <th>Nome</th>
                                        <td>{fetchedData.subject}</td>
                                    </tr>
                                    <tr>
                                        <th>Chave</th>
                                        <td>{fetchedData.envelope_folder_key}</td>
                                    </tr>
                                    <tr>
                                        <th>Status</th>
                                        <td>
                                            <StatusIconText
                                                id={fetchedData.envelope_folder_key}
                                                envelope_folder_status={fetchedData.status}
                                                type="envelope_folder_status"
                                            />
                                        </td>
                                    </tr>
                                    {fetchedData.deactivated_on &&
                                        <tr>
                                            <th>Desativado em</th>
                                            <td>
                                                <DatetimeBlock dateString={fetchedData.deactivated_on} />
                                            </td>
                                        </tr>}
                                </tbody>
                            </S.DataTable>
                            {(fetchedData.envelope_folder_status_events || fetchedData.envelope_folder_step_events || (userRoles.includes("cancel_envelope") && ["draft", "submitted", "collecting"].includes(fetchedData.status))) &&
                                <S.FolderActions>
                                    {(fetchedData.envelope_folder_status_events || fetchedData.envelope_folder_step_events) &&
                                        <BaseButton
                                            label="EVENTOS DA PASTA"
                                            className="btn btn--white btn--animated"
                                            onClick={() => setFolderEventsDialogOpen(true)}
                                        >
                                            <EventNoteIcon style={{ width: "1.8rem", height: "1.8rem" }}/>
                                        </BaseButton>}
                                    {(userRoles.includes("cancel_envelope") && ["draft", "submitted", "collecting"].includes(fetchedData.status)) &&
                                        <BaseButton
                                            label="CANCELAR PASTA"
                                            className="btn btn--red btn--animated"
                                            onClick={() => setCancelDialogOpen(true)}
                                        >
                                            {cancelEnvelopeFolderLoading ?
                                                <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                                :
                                            <CancelRoundedIcon style={{ width: "1.8rem", height: "1.8rem" }}/>}
                                        </BaseButton>}
                                </S.FolderActions>}
                        </li>
                    </ul>
                    <ul className="inbox">
                        <li className="inbox__header">
                            <div className="inbox__cell--left">Dados do Assinante:</div>
                        </li>
                        <li className="inbox__body_d_block">
                            <S.DataTable>
                                <tbody>
                                    <tr>
                                        <th>Nome</th>
                                        <td>{(fetchedData.signer_data || {}).name || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Documento</th>
                                        <td>{(fetchedData.signer_data || {}).document_number || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>E-mail</th>
                                        <td>{(fetchedData.signer_data || {}).email || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th>Telefone</th>
                                        <td>{formatPhoneObjectToFront((fetchedData.signer_data || {}).phone) || "-"}</td>
                                    </tr>
                                </tbody>
                            </S.DataTable>
                        </li>
                    </ul>
                </S.DataTablesRow>
                {(fetchedData.envelopes || []).length !== 0 &&
                    <S.SectionTitle>Envelopes vinculados</S.SectionTitle>}
                <ul className="inbox envelope-folder-page-envelopes-list row-click-list">
                    {(fetchedData.envelopes || []).length !== 0 &&
                        <li className="inbox__header">
                            <div className="inbox__cell--left">Criado em:</div>
                            <div className="inbox__cell--center">Dados do Envelope:</div>
                            <div className="inbox__cell--right">Status:</div>
                        </li>}
                    {(fetchedData.envelopes || []).map((envelope) => (
                        <li
                            key={envelope.envelope_key}
                            className={`inbox__body${userRoles.includes("read_envelope") ? " inbox__body--clickable" : ""}`}
                        >
                            <ErrorBoundary>
                                {userRoles.includes("read_envelope") &&
                                    <a
                                        href={`/envelope/${envelope.envelope_key}`}
                                        className="envelope-row-link"
                                        aria-label="Ver detalhes do envelope"
                                        onClick={(e) => {
                                            if (
                                                e.ctrlKey ||
                                                e.metaKey ||
                                                e.button === 1
                                            ) {
                                                return;
                                            }
                                            e.preventDefault();
                                            navigate(`/envelope/${envelope.envelope_key}`);
                                        }}
                                    />}
                                <div className="inbox__cell--left inbox__cell--row-container">
                                    <DatetimeBlock dateString={envelope.created_at} />
                                </div>
                                <div className="inbox__cell--center">
                                    <DataField
                                        label="Nome do Envelope"
                                        field={envelope.subject}
                                    />
                                    <DataField
                                        label="ID do Envelope"
                                        field={envelope.id}
                                    />
                                </div>
                                <div className="inbox__cell--right inbox__cell--row-container">
                                    <div className="inbox__cell--column-container" style={{ gap: ".4rem", alignItems: "flex-end" }}>
                                        <StatusIconText
                                            id={`${envelope.envelope_key}-decision`}
                                            envelope_decision_status={envelope.decision}
                                            type="envelope_folder_decision"
                                        />
                                        <StatusIconText
                                            id={envelope.envelope_key}
                                            envelope_status={envelope.status}
                                            type="envelope_status"
                                        />
                                    </div>
                                </div>
                            </ErrorBoundary>
                        </li>
                    ))}
                </ul>
                {folderEventsDialogOpen &&
                    <EnvelopeFolderEventsDialog
                        open={folderEventsDialogOpen}
                        setOpen={setFolderEventsDialogOpen}
                        folder={fetchedData}
                    />}
                <CancelEnvelopeFolderErrorDialog
                    cancelEnvelopeFolderError={cancelEnvelopeFolderError}
                    setCancelEnvelopeFolderError={setCancelEnvelopeFolderError}
                />
                <CancelEnvelopeFolderDecisionDialog
                    open={cancelDialogOpen}
                    setOpen={setCancelDialogOpen}
                    handleCancel={() => cancelEnvelopeFolder()}
                />
            </div>
        )
    }
}
